export const isTradingBlockSamePasswordError = (error: any) =>
  error?.response?.data?.error === 'TradingBlockSamePasswordError';
